import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ToolBar from "./ToolBar";
import ParkingActiveList from "./ParkingActiveList";
import { fetchParkingActive } from "../../../redux/actions/parkingActive";
import { fetchParkingPlaces } from "../../../redux/actions/parkingPlace";
import { Skeleton } from "@mui/material";
import ParkingActiveDetail from "../../../components/modal/ParkingActive"
import { getDateMonthAgo } from "../../../utils";
import { useDebounce } from "../../../hooks/useDebounce";


function BackOfficeParkingActive(props) {
    const {
        userUseCases,
        parkingActive,
        parkingPlaces,
        fetchParkingActive,
        fetchParkingPlaces,
        isFetchingAllList,
    } = props;

    const [isFetchedParkingActive, setIsFetchedParkingActive] = useState(false);
    const [isFetchedParkingPlaces, setIsFetchedParkingPlaces] = useState(false);
    const [filter, setFilter] = useState({ dateFrom: getDateMonthAgo() });
    const [selectedPlace, setSelectedPlace] = useState();
    const [table, setTable] = useState(false);
    const [parkingPlacesValues, setParkingPlacesValues] = useState();
    const [openDetail, setOpenDetail] = useState(false);
    const [parkingActiveDetail, setParkingActiveDetail] = useState({});
    const fetchParkingActiveDebounced = useDebounce((filter) => {
        fetchParkingActive(filter.selectedPlace ? filter.selectedPlace.key : null,
            filter.query,
            filter.state,
            filter.mbsSuccess,
            filter.dateFrom,
            filter.dateTo)
            .then(() => {
                setIsFetchedParkingActive(true);
            })
            .catch((err) => {
                console.log(err);
                setIsFetchedParkingActive(false);
            });
    }, 200, [fetchParkingActive]);

    useEffect(() => {
        if (!isFetchedParkingActive) {
            fetchParkingActiveDebounced(filter);
        }

        if (!isFetchedParkingPlaces) {
            fetchParkingPlaces()
                .then(() => {
                    setIsFetchedParkingPlaces(true);
                })
                .catch((err) => {
                    console.log(err);
                    setIsFetchedParkingPlaces(false);
                });
        }
    }, [
        fetchParkingActive,
        filter,
        isFetchedParkingActive,
        fetchParkingPlaces,
        isFetchedParkingPlaces
    ]);

    const handleFilter = (item) => (value) => {
        if (value?.target?.value != undefined) {
            setFilter({ ...filter, [item]: value.target.value ? value.target.value : '' });
        } else {
            setFilter({ ...filter, [item]: value });
        }

        if (item === 'dateFrom' || item === 'dateTo') {
            try {
                new Date(value).toISOString();
                setIsFetchedParkingActive(false);
            } catch (error) {
            }
        } else {
            setIsFetchedParkingActive(false);
        }
    };

    const handleSelectedPlace = (value) => {
        setSelectedPlace(value);
        setFilter({ ...filter, selectedPlace: value });
        setIsFetchedParkingActive(false);
    }

    const handleParkingActiveDetail = (data) => {
        setParkingActiveDetail(data);
        setOpenDetail(true);
    }

    const hadleCloseDetail = () => {
        setOpenDetail(false);
    }

    useEffect(() => {
        if (parkingPlaces) {
            setParkingPlacesValues(
                parkingPlaces.map((a) => {
                    return { value: a.parkingPlaceId, label: a.name, key: a.parkingPlaceId };
                }),
            );
        }
    }, [parkingPlaces]);

    return (
        <>
            {!isFetchingAllList ? (
                <ToolBar
                    userUseCases={userUseCases}
                    filter={filter}
                    handleFilter={handleFilter}
                    parkingPlaces={parkingPlacesValues}
                    selectedPlace={selectedPlace}
                    handleSelectedPlace={handleSelectedPlace}
                    table={table}
                    setTable={setTable}
                />
            ) : (
                <Skeleton
                    height={200}
                    sx={{
                        width: "86%",
                        marginLeft: "30px",
                    }}
                    animation="wave"
                />
            )}

            {!isFetchingAllList ? (
                <div>
                    <ParkingActiveList
                        userUseCases={userUseCases}
                        parkingActive={parkingActive}
                        isLoading={isFetchingAllList}
                        table={table}
                        handleParkingActiveDetail={handleParkingActiveDetail}
                    />
                </div>
            ) : (
                <Skeleton
                    variant="rounded"
                    height="calc(100vh - 200px)"
                    sx={{
                        width: "86%",
                        marginLeft: "30px",
                    }}
                    animation="wave"
                />
            )}
            <ParkingActiveDetail
                open={openDetail}
                handleClose={hadleCloseDetail}
                parkingActive={parkingActiveDetail}
            />
        </>
    );
}

const mapStateToProps = (store) => ({
    userUseCases: store.authData.userUseCases,
    parkingActive: store.parkingActiveDate.parkingActive,
    parkingPlaces: store.parkingPlaceData.parkingPlaces,
    isFetchingAllList: store.usersData.isFetchingParkingList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchParkingActive,
            fetchParkingPlaces,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeParkingActive);
